import React from 'react';
import classNames from 'classnames';
import { Button, ButtonModes } from '@hallmark/web.core.buttons.button';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { BrandColors } from '@hallmark/web.styles.colors';
import { ButtonGroup } from '../../../button-group/button-group';
import { ColorOptionProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const ColorOption = ({
  addClass = '',
  colors,
  selectedColor,
  label,
  labelColor = BrandColors.Disabled,
  labelVariant = TypographyVariants.FieldLabel,
  testId = 'color-option',
  buttonGroupClick,
}: ColorOptionProps): React.ReactElement => {
  const classes = classNames(styles['color-option'], addClass);

  return (
    <div className={classes} data-testid={testId}>
      <Typography addClass={styles.label} variant={labelVariant || TypographyVariants.FieldLabel} color={labelColor}>
        {label}
      </Typography>
      <ButtonGroup
        ariaLabel="Text Color"
        addClass={styles['button-group']}
        defaultClickedIndex={colors.indexOf(selectedColor)}
      >
        {colors.map((colorName, index) => (
          <Button
            click={() => buttonGroupClick(colorName)}
            mode={ButtonModes.Icon}
            ariaLabel={colorName}
            addClass={classNames(styles[`color-${colorName}`], styles.buttons)}
            testId={`color-button-${colorName}`}
            key={index}
          >
            <Typography variant={TypographyVariants.SRT}>{colorName}</Typography>
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};
